import { createAction } from 'redux-act';

export const getAnnouncements = createAction();
export const receivedAnnouncements = createAction();
export const getAnnouncementsError = createAction();
